export const getCustomFieldDecorator = (
  key: string = "",
  initialValue: any,
  rules: any[] = []) => {
  return ({
    rules,
    initialValue
  });
};
